<div
  class="xi-modal__container callback-url-dialog__container"
  *transloco="let t; read: 'callback-url-dialog-component'"
>
  <h2 class="xi-modal__title">{{ t('set-url') }}</h2>

  <div class="xi-modal__content callback-url-dialog__content">
    <form [formGroup]="urlForm">
      <div class="callback-url__url">
        <xi-input-field
          label="{{ t('url') }}"
          placeholder="{{ t('url-placeholder') }}"
          formControlName="url"
          icon="cancel"
          [prePopulateStatus]="true"
          [status]="
            urlForm.dirty && urlForm.controls.url.invalid
              ? { state: 'error', text: t('invalid-url') }
              : urlForm.dirty && !urlForm.controls.url.invalid
                ? { state: 'success' }
                : { state: 'success' }
          "
          (onIconClick)="urlForm.patchValue({ url: '' })"
        ></xi-input-field>
      </div>
    </form>

    <p [innerHtml]="t('information')"></p>
  </div>

  <div class="xi-modal__actions callback-url-dialog__actions">
    <xi-default-button
      text="{{ t('cancel') }}"
      fill="text"
      (onClick)="cancel()"
    ></xi-default-button>

    <xi-default-button
      text="{{ t('set') }}"
      (onClick)="save()"
      [disabled]="urlForm.invalid"
    ></xi-default-button>
  </div>
</div>
